export const OPENAI = "sk-proj-DEMOvibeauditFakeKeyNotRealvibeauditFakeKeyNotRealvibeauditFakeKeyNotReal0000";